import { render, staticRenderFns } from "./ShiftsPage.vue?vue&type=template&id=20b3fe34&lang=pug&"
import script from "./ShiftsPage.vue?vue&type=script&lang=js&"
export * from "./ShiftsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports